import { z } from 'zod';
import {
  EmployeeAssistanceStatus,
  EmployeeExecutionAdvisoryCategory,
  EmployeeExecutionBlockerCategory,
} from '../../../../api/generated';
import { globalSearchSchema } from '../../../shared/schemas/search.schema';

const optionalPositiveIntegerSchema = z.preprocess(
  (value) => (value === '' || value == null ? undefined : value),
  z.coerce.number().int().positive().optional()
);

/** URL search contract for the tenant-wide AI Agent assistance inbox. */
export const assistancesSearchSchema = globalSearchSchema.merge(
  z.object({
    phoneVersion: globalSearchSchema.shape.phoneVersion.default('v1' as const),
    status: z
      .enum(EmployeeAssistanceStatus)
      .default(EmployeeAssistanceStatus.OPEN),
    employeeId: z.string().trim().min(1).optional(),
    category: z
      .union([
        z.enum(EmployeeExecutionBlockerCategory),
        z.enum(EmployeeExecutionAdvisoryCategory),
      ])
      .optional(),
    conversationId: optionalPositiveIntegerSchema,
    from: z.string().optional(),
    to: z.string().optional(),
  })
);

/** Parsed AI Agent assistance route search. */
export type AssistancesSearch = z.infer<typeof assistancesSearchSchema>;
